const handleSizeGuide = (event) => {
  let sizeGuide = document.querySelector('.size-guide')
  if(!sizeGuide) return

  if(event === 'open') {
    document.body.classList.add("no-scroll")
    sizeGuide.classList.add("open")
  }else {
    document.body.classList.remove("no-scroll")
    sizeGuide.classList.remove("open")
  }
}

const showActiveValues = (value, sizeGuideColumns) => {
  let column = value.parentElement
  let valueIndex = parseInt(value.dataset.index)

  for(let i=0; i<valueIndex; i++) {
    if(i === 0) column.children[i].classList.add('active-dark')
    else column.children[i].classList.add('active')
  }

  sizeGuideColumns.forEach((sizeGuideColumn, i) => {
    if(i === 0 || i === parseInt(column.dataset.index)) sizeGuideColumn.children[valueIndex].classList.add('active-dark')
    else sizeGuideColumn.children[valueIndex].classList.add('active')
  })
}

const hideActiveValues = (sizeGuideColumns) => {
  sizeGuideColumns.forEach(column => {
    [...column.children].forEach(value => {
      value.classList.remove('active')
      value.classList.remove('active-dark')
    })
  })
}

const listenHoverSizeGuide = () => {
  let sizeGuideColumns = [...document.querySelectorAll('.size-guide__table .column')]
  if(!!!sizeGuideColumns.length) return

  sizeGuideColumns.forEach(column => {
    [...column.children].forEach(value => {
      if(value.classList.contains('column-value')) {
        value.addEventListener("mouseenter", event => showActiveValues(event.target, sizeGuideColumns))
        value.addEventListener("mouseleave", event => hideActiveValues(sizeGuideColumns))
      }
    })
  })
}

const listenHoverVariantSizes = () => {
  let sizes = [...document.querySelectorAll('.size-selector input')]
  let columns = [...document.querySelectorAll('.size-guide__table .column')]
  let popups = [...document.querySelectorAll('.size-selector .popup-related-sizes .related-sizes')]
  if(!!!sizes.length || !!!columns.length || !!!popups.length) return

  let HTMLPopUpTemplate = ''

  sizes.forEach((size, index) => {
    HTMLPopUpTemplate = ''

    let valueIndex = [...columns[0].children].findIndex(value => value.textContent === size.value)
    if(valueIndex !== -1) {
      columns.forEach((column, index) => {
        if(index > 0) HTMLPopUpTemplate += `<p><span>${column.children[0].textContent}:</span> ${column.children[valueIndex].textContent}</p>`
      })
    }

    popups[index].insertAdjacentHTML('afterbegin', HTMLPopUpTemplate)

    if(window.innerWidth < 720) {
      size.nextElementSibling.insertAdjacentElement('afterend', popups[index].parentElement.cloneNode(true))
      popups[index].parentElement.remove()
    }
  })
}

document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("keyup", event => {
    if(event.key !== 'Escape') return
    handleSizeGuide('close')
  })

  document.addEventListener("click", event => {
    if(event.target.closest('#OpenSizeGuideBtn')) {
      handleSizeGuide('open')
      return
    }
    if(event.target.closest('#CloseSizeGuideBtn')) {
      handleSizeGuide('close')
      return
    }
    if(event.target.closest('.size-guide__container')) return
    
    handleSizeGuide('close')
  })

  listenHoverSizeGuide()
  listenHoverVariantSizes()
})